export let commands = {
    focusSkipLinks: {
        hotmail: 'ctrl+f6',
        yahoo: 'ctrl+f6',
        gmail: 'ctrl+f6',
        owa: 'ctrl+f6',
    },
};
